import { registerRenderer, BUILTIN_RENDERERS, getVisualizationDefinition } from '@deckspace/ui';
import { withDataset } from './visualizations/withDataset';

/**
 * Register every built-in renderer against `@deckspace/ui`'s registry.
 * Data-backed types (per the catalog's `isDataBacked` flag) are wrapped with
 * `withDataset` so SurfaceRenderer dispatches the same way for every type —
 * the HOC handles the fetch. The catalog is the single source of truth.
 *
 * Called once at app startup before `createRoot.render`. Idempotent.
 */
export function bootstrapRenderers(): void {
  for (const [type, View] of Object.entries(BUILTIN_RENDERERS)) {
    const def = getVisualizationDefinition(type);
    if (!def) {
      console.warn(`[catalog-bootstrap] no catalog definition for renderer '${type}'`);
      continue;
    }
    if (def.isDataBacked) {
      // View's specific generic doesn't unify with the registry's RendererProps;
      // the HOC enforces the surface shape at runtime.
      registerRenderer(type, withDataset(View as never) as never);
    } else {
      registerRenderer(type, View);
    }
  }
}
